// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3n5y0","box":"WorkspacesBox_box__UDYsO","node":"WorkspacesBox_node__2Y8qV"};